/**
 * @generated SignedSource<<837d88c1cbfba75ba5786b29828c13ed>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type StreamAccessType = "full" | "partial" | "shared";
import { FragmentRefs } from "relay-runtime";
export type context_StreamUsersTypeContext_streamUsers$data = {
  readonly notestreamusers: ReadonlyArray<{
    readonly accessType: StreamAccessType;
    readonly id: string;
    readonly user: {
      readonly account: {
        readonly id: string;
        readonly name: string;
      };
      readonly email: string;
      readonly firstName: string;
      readonly fullName: string;
      readonly hasReceivedInvites: boolean;
      readonly id: string;
      readonly image: string;
      readonly isActive: boolean;
      readonly isConfigured: boolean;
      readonly isExternal: boolean;
      readonly isGuest: boolean;
      readonly isTopUser: boolean;
      readonly lastName: string;
    };
  }>;
  readonly " $fragmentType": "context_StreamUsersTypeContext_streamUsers";
};
export type context_StreamUsersTypeContext_streamUsers$key = {
  readonly " $data"?: context_StreamUsersTypeContext_streamUsers$data;
  readonly " $fragmentSpreads": FragmentRefs<"context_StreamUsersTypeContext_streamUsers">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "context_StreamUsersTypeContext_streamUsers",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteStreamUser",
      "kind": "LinkedField",
      "name": "notestreamusers",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accessType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "email",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "image",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fullName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "firstName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isActive",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isConfigured",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isGuest",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasReceivedInvites",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isTopUser",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isExternal",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "account",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NoteStream",
  "abstractKey": null
};
})();

(node as any).hash = "4bd5155a7a5948d13b1dc139bacef84e";

export default node;
